// extracted by mini-css-extract-plugin
export var actionButton = "_52-1";
export var actionButtons = "_52-2";
export var actions = "_52-0";
export var aiUnread = "_52-10";
export var alignCenter = "_52-h";
export var backWrapper = "_52-3";
export var cellContainer = "_52-4";
export var checkboxContainer = "_52-5";
export var contentContainer = "_52-6";
export var contentHeader = "_52-8";
export var conversationsTableWrapper = "_52-s";
export var draftReplyBadgeContainer = "_52-m";
export var dropdownItem = "_52-b";
export var dropdownItemsContainer = "_52-a";
export var dropdownTitle = "_52-c";
export var errorIcon = "_52-7";
export var filter = "_52-d";
export var gray = "_52-i";
export var headerActionButtons = "_52-e";
export var headerCheckboxContainer = "_52-f";
export var icon = "_52-j";
export var menuContainer = "_52-k";
export var noMoreTicketsIcon = "_52-12";
export var noMoreTicketsSubText = "_52-13";
export var oneLine = "_52-l";
export var optionsButton = "_52-n";
export var plus = "_52-o";
export var portalButtonsWrapper = "_52-g";
export var red = "_52-p";
export var scrolledTop = "_52-9";
export var search = "_52-q";
export var selectedConversationsCount = "_52-r";
export var spinner = "_52-t";
export var strong = "_52-u";
export var summaryCell = "_52-v";
export var tableContainer = "_52-11";
export var tagContainer = "_52-w";
export var threeDots = "_52-x";
export var twoLines = "_52-y";
export var unread = "_52-z";